import Enumerator from './Enumerator';

export const transactionTypes = [
  'none',
  'purchase',
  'refinance',
  'top_up_or_increase',
  'equity_release'
];

export class TransactionType extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'purchase';
        break;
      case '2':
        correctOption = 'refinance';
        break;
      case '3':
        correctOption = 'top_up_or_increase';
        break;
      case '4':
      case '5':
        correctOption = 'equity_release';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

TransactionType.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  purchase: {
    get title() {
      return 'Purchase';
    }
  },
  refinance: {
    get title() {
      return 'Refinance';
    }
  },
  top_up_or_increase: {
    get title() {
      return 'Top-up/Increase';
    }
  },
  equity_release: {
    get title() {
      return 'Equity release';
    }
  }
});

export default {
  transactionTypes,
  TransactionType
};
